import React, { PureComponent } from 'react';
import Searchbar from './searchbar';
import PopularityDropdown from './popularityDropdown';

class FilterBar extends PureComponent {

  onResetFilterClick(e, activeFilter){
    e.preventDefault();
    this.props.onSelect(activeFilter);
  }

  renderFilterText(deviceType){
    return (
        <div className={`filter-bar-text-group ${deviceType}`}>
          <p className="filter-bar-text">
              <span className="trip-text">
                {this.props.data.length} Trips
              </span>
              <br/>
              <span className="filtered-text">
                { (this.props.active !== "") ? `found for ${this.props.active}` : `found` }
              </span>
            </p>
            <p className="departure-text">
               { (this.props.departureActive) ? `${this.props.departureDatesFilter}  |    `  : ""  }
              <button style={{display:this.props.active === "" ? "none": "inline-block" }}  onClick={e => this.onResetFilterClick(e, null)}>reset filters</button>
            </p>
        </div>
    )
  }

  renderMobileFilter(_type, _activeDropDown, _onDropDown){
    if(this.props.mobileFilterActive){
      return  <div className="mobile-filter-text">Filter Results</div>
    }else{
      return (
        <div className="row">
          <div className="columns small-6">
            {this.renderFilterText("small")}
          </div>
          <div className="columns small-6">
            <PopularityDropdown popularityType={_type} activeDropDown={_activeDropDown}  onDropDown={_onDropDown} />
          </div>
        </div>
      )
    }
  }



  render(){

      return (
        <div className={`filter-bar ${this.props.mobileFilterActive ? 'active' : ''}`}>
          <div className="row">
            <div className="columns small-12 medium-4 large-3">
                { this.renderFilterText("big") }
            </div>

            <div className="columns small-12 medium-8 large-9">

              <Searchbar
                filterReset={this.props.onSelect}
                searchResults={this.props.searchResults}
                searchResultContinentOnSelect={this.props.searchResultContinentOnSelect}
                searchResultTravelStyleOnSelect={this.props.searchResultTravelStyleOnSelect}
                searchResultCountryOnSelect={this.props.searchResultCountryOnSelect}
                mobileFilterSelect={this.props.mobileSelect}
                mobileFilterActive={this.props.mobileFilterActive}
              />

              <PopularityDropdown popularityType="" activeDropDown={this.props.activeDropDown}  onDropDown={this.props.onDropDown} />

              { this.renderMobileFilter("mobile",this.props.activeDropDown, this.props.onDropDown)}

            </div>
          </div>
        </div>
      )
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/search/components/filters/filterbar.js